import { ShieldCheck, Clock, BadgeCheck, Handshake, Sparkles, HeartHandshake } from 'lucide-react';
import { IDS } from '@/constants/testIds';
import { useReveal } from '@/hooks/useReveal';

const REASONS = [
  { icon: BadgeCheck, title: 'Licensed & Empanelled', text: 'Registered contractor with valid class registration and empanelments.' },
  { icon: Clock, title: 'On-time Delivery', text: 'Milestone-driven execution with weekly progress reporting.' },
  { icon: ShieldCheck, title: 'Safety Compliance', text: 'Strict PPE, HSE and quality inspection protocols on every site.' },
  { icon: Sparkles, title: 'Quality First', text: 'Materials tested at NABL-accredited labs and audited by third parties.' },
  { icon: Handshake, title: 'Transparent Billing', text: 'GST-compliant invoicing and clear measurement books for every stage.' },
  { icon: HeartHandshake, title: 'Community Focused', text: 'Local employment, local suppliers — projects that uplift the region.' },
];

const BADGES = ['Railways Registered', 'MSME Registered', 'GST Compliant', 'PAN Verified'];

const ReasonCard = ({ r, delay }) => {
  const rv = useReveal(delay);
  const Icon = r.icon;
  return (
    <div ref={rv.ref} className={`${rv.className} bg-white p-8 hover:bg-navy-900 group transition-colors duration-500`}>
      <Icon className="w-9 h-9 text-gold-500 group-hover:text-gold-300 transition-colors" />
      <h3 className="mt-6 font-serif text-2xl text-navy-800 group-hover:text-white transition-colors">
        {r.title}
      </h3>
      <p className="mt-3 text-sm text-navy-600 group-hover:text-white/80 transition-colors leading-relaxed">
        {r.text}
      </p>
    </div>
  );
};

export const WhyUs = () => {
  const heading = useReveal(0);
  return (
    <section data-testid={IDS.whyUs.section} className="py-24 md:py-32 bg-cream">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div ref={heading.ref} className={`${heading.className} max-w-3xl mb-16`}>
          <div className="flex items-center gap-3 mb-6">
            <span className="gold-rule" />
            <span className="text-xs tracking-[0.28em] uppercase text-gold-500 font-bold">
              Why Choose Us
            </span>
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl text-navy-800 tracking-tight leading-[1.1]">
            Built on integrity. Delivered with discipline.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-navy-100 border border-navy-100">
          {REASONS.map((r, i) => (
            <ReasonCard key={r.title} r={r} delay={i * 60} />
          ))}
        </div>

        {/* Certification badges */}
        <div className="mt-16 flex flex-wrap gap-3 justify-center">
          {BADGES.map((b) => (
            <span
              key={b}
              className="rounded-full border border-gold-400 text-navy-800 px-5 py-2 text-xs tracking-[0.2em] uppercase font-semibold bg-white/50 backdrop-blur-sm"
            >
              {b}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
